import MobileViewGenerator from '../../../MobileViewGenerator/MobileViewGenerator';
import SimpleListItem from '../../../MobileViewGenerator/subdirectives/list/SimpleList/SimpleList';
import SimpleEditItem from '../../../MobileViewGenerator/subdirectives/edit/SimpleEdit/SimpleEdit';

export default MobileViewGenerator(SimpleListItem, SimpleEditItem);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/common/directives/schedules/scheduleTypes/editable/Mobile/Mobile.js
// module id = 384
// module chunks = 0